<template>
  <div class="print-template">
    <!-- 5多个业务-不含检测报告及配件费明细-->
    <div id="part1">
      <h3 style="text-align:center;font-size:20px;font-weight:bold">{{printDetail.titleDetail.name}}</h3>
      <h3 style="text-align:center;font-size:20px;font-weight:bold">维修报价单</h3>
      <div style="display:flex;width:100%">
        <el-descriptions :column="1" style="width:49.5%" v-for="(item, index) in getPart1Table()" :key="index">
           <el-descriptions-item :label="key" v-for="(val, key, index) in item" :key="index">{{val}}</el-descriptions-item>
        </el-descriptions>
        <!-- <el-descriptions :column="1" style="width:49.5%">
          <el-descriptions-item label="TO 收件人：">{{printDetail.customerCompanyContactDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="E-mail 电邮：">{{printDetail.receivingEmail}}</el-descriptions-item>
          <el-descriptions-item label="Company 公司：">{{printDetail.customerCompanyDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="Fax 传真：">{{printDetail.customerCompanyDetail.fax}}</el-descriptions-item>
        </el-descriptions>
        <el-descriptions :column="1">
          <el-descriptions-item label="Quote From 报价人：">{{printDetail.salesManDetail.name}}</el-descriptions-item>
          <el-descriptions-item label="Tel 电话：">{{printDetail.salesManDetail.phone}}</el-descriptions-item>
          <el-descriptions-item label="Return Fax 传真：">{{printDetail.salesManDetail.fax}}</el-descriptions-item>
          <el-descriptions-item label="E-Mail 电邮：">{{printDetail.salesManDetail.email}}</el-descriptions-item>
        </el-descriptions> -->
      </div>
    </div>
    <vxe-table
      border
      show-footer
      ref="xTable"
      align="center"
      class="mt-20"
      :print-config="tablePrint"
      keep-source
      auto-resize
      :column-config="{ resizable: true }"
      :footer-method="footerMethod"
      :merge-footer-items="mergeFooterItems"
      :data="tableData"
      >
      <vxe-column type="seq" width="50" title="序号"></vxe-column>
      <vxe-column field="businessNo" title="编号" min-width="120"/>
      <vxe-column field="businessName" title="名称" min-width="120"/>
      <vxe-column field="businessModel" title="型号" min-width="100"/>
      <vxe-column field="amount" title="数量" width="60" />
      <vxe-column field="price" title="含税单价" min-width="100" header-align="center">
        <template #default="{ row }">
          {{$currency(row.price)}}
        </template>
      </vxe-column>
      <vxe-column field="totalPrice" title="含税总价" min-width="100" header-align="center">
        <template #default="{ row }">
          {{$currency(row.price * row.amount)}}
        </template>
      </vxe-column>
      <vxe-column field="businessSerial" title="备注" min-width="100" />
    </vxe-table>

    <div id="part2" class="sign-container">
      <h4 class="form-title">备注：</h4>
      <pre>{{printDetail.quotationMarkTemplateDetail.mark}} </pre>
      <div style="display:flex;width:100%;margin-top:100px;">
        <div style="width:49%">
          客户代表方签字：<span class="sign-container-border" />
        </div>
        <div style="position:relative">
          业务签字：<span class="sign-container-border" />
          <ZPreview :authSrc="printDetail.titleDetail.sealImg" width="100px" height="100px" class="upload-file_preview" />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, ref } from 'vue'
import ZPreview from '@/components/common/ZPreview.vue'
import { VxeTablePropTypes, VxeTableInstance } from 'vxe-table'
import { tablePrint, signContainer } from '@/utils/print'
import $number from 'number-precision'
import $currency from 'currency.js'

export default defineComponent({
  components: {
    ZPreview
  },
  props: {
    detail: { type: Object, required: true, default: () => null }
  },
  setup(props) {
    const xTable = ref<VxeTableInstance>()
    const dataMap = reactive({
      printDetail: props.detail,
      tablePrint,
      tableData: props.detail.details,
      mergeCells: [] as VxeTablePropTypes.MergeCell[],
      mergeFooterItems: [
        { row: 0, col: 0, rowspan: 1, colspan: 5 }
      ] as VxeTablePropTypes.MergeFooterItem[],
      column: [{
        name: '项目',
        field: '',
        type: 'seq',
        width: '60'
      }, {
        name: '编号',
        field: 'businessNo',
        width: '160'
      }, {
        name: '名称',
        field: 'businessName',
        width: '160'
      }, {
        name: '型号',
        field: 'businessModel'
      }, {
        name: '数量',
        field: 'amount'
      }, {
        name: '含税单价',
        field: 'price',
        width: '160'
      }, {
        name: '含税总价',
        field: 'totalPrice',
        width: '160'
      }, {
        name: '备注(序列号)',
        field: 'businessSerial',
        width: '160'
      }]
    })
    const printEvent1: () => void = () => {
      const $table = xTable.value as any
      $table.print({
        isMerge: true,
        style: signContainer,
        beforePrintMethod: ({ content }: any) => {
          // 拦截打印之前，返回自定义的 html 内容
          const part1 = document.getElementById('part1') as any
          const part2 = document.getElementById('part2') as any
          return part1.innerHTML + content + part2.innerHTML
        }
      })
    }
    const exportEvent = (type: string) => {
      const $table = xTable.value as any
      $table.exportData({
        filename: `报价单_${dataMap.printDetail.no}`,
        type,
        isMerge: true,
        beforeExportMethod: ({ content }: any) => {
          // 拦截打印之前，返回自定义的 html 内容
          const part1 = document.getElementById('part1') as any
          const part2 = document.getElementById('part2') as any
          return part1.innerHTML + content + part2.innerHTML
        }
      })
    }
    const exportEventElement = () => {
      console.log(333)
    }

    const sumNum = (list: any[], field: string) => {
      let count = 0
      list.forEach(item => {
        const num = item[field] ? Number(item[field]) : 0
        count = $number.plus(count, num)
      })
      return count
    }
    const sumTotalNum = (list: any[]) => {
      let count = 0
      list.forEach(item => {
        const num = item.price * item.amount
        count = $number.plus(count, num)
      })
      return count
    }
    const footerMethod: VxeTablePropTypes.FooterMethod = ({ columns, data }) => {
      const sums: any[] = []
      columns.forEach((column, columnIndex) => {
        if (columnIndex === 0) {
          sums.push('总计')
        } else {
          let sumCell: any = null
          switch (column.field) {
            // case 'price':
            //   sumCell = $currency(sumNum(data, column.field))
            //   break
            case 'totalPrice':
              sumCell = $currency(sumTotalNum(data))
              break
            case 'amount':
              sumCell = sumNum(data, column.field)
              break
            case 'businessSerial':
              sumCell = `含${props.detail.taxRate}%的稅`
              break
          }
          sums.push(sumCell)
        }
      })
      // 返回一个二维数组的表尾合计
      return [sums]
    }
    const getPart1Table = () => {
      const { customerCompanyContactDetail, customerCompanyDetail, salesManDetail, titleDetail } = dataMap.printDetail
      return [
        {
          'TO 收件人：': customerCompanyContactDetail.name,
          'E-mail 电邮：': customerCompanyContactDetail.receivingEmail,
          'Company 公司：': customerCompanyDetail.name,
          'Tel 电话：': customerCompanyContactDetail.phone
        }, {
          'Quote From 报价人：': salesManDetail.name,
          'Tel 电话：': salesManDetail.phone,
          'Line 座机：': titleDetail.phone,
          'E-Mail 电邮：': salesManDetail.email
        }
      ]
    }

    return {
      ...toRefs(dataMap),
      xTable,
      printEvent1,
      footerMethod,
      exportEvent,
      exportEventElement,
      getPart1Table
    }
  }
})
</script>
<style lang="scss">
.print-template{
  .table-descri{
    .is-bordered-label{
      width: 180px;
      background: #fff;
    }
  }
  .sign-container-border{
    border: 1px solid rgba(0,0,0,.7);
    height: 0px;
    width: 200px;
    display: inline-block;
  }
  .upload-file_preview{
    position: absolute;
    top: -45px;
    left: 130px;
  }
  pre {
    white-space: pre-wrap;
    word-break: break-all;
    max-width: 100%;
    font-family: inherit;
  }
  #part1, #part2 {
    max-width: 100%;
  }
}

</style>
